export default {
  metadata: {
    version: '1.0.0',
    id: 'mega-menu-1.0.0',
    name: 'JDSMegaMenuInternal',
    platform: 'web'
  },
  hierarchy: {
    container: ['jds_mega_menu_block']
  },
  base: {
    container: {
      width: '{m_1}',
      'flex-direction': '{m_2}',
      'justify-content': '{m_3}',
      'align-items': '{m_4}',
      'background-color': '{m_5}',
      'padding-top': '{m_6}',
      'padding-bottom': '{m_7}',
      'padding-right': '{m_8}',
      'padding-left': '{m_9}',
      gap: '{m_10}'
    }
  },
  variant: {},
  api: {
    config: {
      open: {
        values: [false, true]
      }
    },
    data: {
      container: {
        value: {
          type: 'list',
          name: 'items',
          object: {
            heading: 'string',
            subLinks: 'list'
          }
        }
      },
      jds_mega_menu_block: {
        title: {
          type: 'string',
          name: 'items.heading'
        },
        links: {
          type: 'list',
          name: 'items.subLinks'
        }
      }
    },
    events: {
      container: {
        onHoverEnd: 'onHoverEnd'
      }
    },
    a11y: {
      container: {
        name: 'items',
        repeating: {
          ariaLabel: 'linkAriaLabel',
          ariaDescribedby: {
            name: 'linkAriaDescribedby',
            platform: 'web,ios'
          }
        }
      }
    }
  }
};
